import styled from 'styled-components'
import { Box, Text } from '@lojinha/design-system'

export const Row = styled(Box)<{ index: number }>(({ theme, index }) => {
  const borderTop = !!index
    ? ''
    : `border-top: 1px solid ${theme.colors.gray200};`

  return `
    display: flex;
    justify-content: space-between;
    ${borderTop}
    border-bottom: 1px solid ${theme.colors.gray200};
  `
})

export const TextEllipsis = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 16px;
`
